import { render, staticRenderFns } from "./DistribuicaoDeRequisicaoDeCompraView.vue?vue&type=template&id=09a0dd47&scoped=true"
import script from "./DistribuicaoDeRequisicaoDeCompraView.vue?vue&type=script&setup=true&lang=js"
export * from "./DistribuicaoDeRequisicaoDeCompraView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DistribuicaoDeRequisicaoDeCompraView.vue?vue&type=style&index=0&id=09a0dd47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a0dd47",
  null
  
)

export default component.exports